<div class="content" role="main">

  <h2>INCI Alerts Call</h2>
  <p>Search witch alerts list one or several INCI triggers</p>

  <form class="forms widthMax" [formGroup]="getINCIAlertsForm" (ngSubmit)="onSubmit()">

        <mat-form-field class="chip-list">
          <mat-chip-list #chipListINCI >
            <ng-container *ngTemplateOutlet="chip context: INCIChipElement"></ng-container>
            <input
              placeholder="Add INCI..."
              #INCIInput
              [formControl]="INCICtrl"
              [matChipInputFor]="chipListINCI"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matAutocomplete]="autoINCIExactMatch"
              (matChipInputTokenEnd)="add($event, INCICtrl, INCIChipElement.arrayString, INCIChipElement.formArrayName, true)">
          </mat-chip-list>
          <mat-autocomplete #autoINCIExactMatch="matAutocomplete" (optionSelected)="selected($event,INCICtrl, INCIChipElement.arrayString, INCIChipElement.formArrayName, true)">
            <mat-option *ngFor="let INCI of usefulFunctionsService.possibleINCIs" [value]="INCI">
              {{INCI}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

    <!-- [disabled]="!getINCIAlertsForm.valid || getINCIAlertsForm.value.INCIs.length == 0" -->
    <button mat-raised-button color="accent" type="submit" class="margin" >Submit</button>

  </form>

<!--  <p> Form Values: {{results | json}}</p>-->


  <ng-container *ngFor="let table of tables">

    <h2 id="table-title"> {{table.title}}</h2>
    <table mat-table [dataSource]="table.dataSource" class="mat-elevation-z8">

      <ng-container
        *ngFor="let string of table.displayedColumns"
        matColumnDef="{{string}}">
        <th mat-header-cell *matHeaderCellDef > {{string}} </th>
        <td mat-cell *matCellDef="let element">
          <p *ngIf="element[string] == 1 else normalTd" class="red" >{{element[string]}} </p>
          <ng-template #normalTd>
            <p>{{element[string]}} </p>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="table.displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: table.displayedColumns;"></tr>
    </table>
  </ng-container>

    <button mat-raised-button color="primary" type="button" class="margin" (click)="usefulFunctionsService.downloadData(results, 'INCIAlerts')" [disabled]="!results">Download Results</button>

</div>




<!-- TEMPLATES -->

<!-- Chip Element -->
<ng-template #chip let-arrayString="arrayString" let-formArrayName="formArrayName">
  <mat-chip
    *ngFor="let string of arrayString"
    [selectable]="selectable"
    [removable]="removable"
    (removed)="chipListComponent.remove(string, arrayString,formArrayName, this.getINCIAlertsForm)">
    {{string}}
    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
  </mat-chip>
</ng-template>

<ng-template #column let-name="name">
  <ng-container matColumnDef="{{name}}">
    <th mat-header-cell *matHeaderCellDef> {{name}} </th>
    <td mat-cell *matCellDef="let element"> {{element[name]}} </td>
  </ng-container>
</ng-template>
